type TokenErrorCode = "expired_token" | "malformed_token";

const isRecord = (value: unknown): value is Record<string, unknown> =>
	typeof value === "object" && value !== null;

export const isSessionTokenErrorCode = (code: unknown): code is TokenErrorCode =>
	code === "expired_token" || code === "malformed_token";

export const extractAuthErrorCode = (error: unknown): string | null => {
	if (!isRecord(error)) {
		return null;
	}

	if (typeof error.code === "string") {
		return error.code;
	}

	if (!isRecord(error.error)) {
		return null;
	}

	return typeof error.error.code === "string" ? error.error.code : null;
};

export const isSessionTokenError = (error: unknown): boolean => {
	const code = extractAuthErrorCode(error);
	return isSessionTokenErrorCode(code);
};
